import { useEffect, useState } from 'react';
import { api } from '../api/client';

export { fillMarkets, formatMarketList, shortMarketName, MARKETS_PENDING } from './marketCopy';

/**
 * The markets the field position is open in, from the server's own list.
 *
 * Served on the public config (GET /api/config) so a signed-out visitor reading the job posting
 * sees exactly the markets a signed-in applicant is offered at the Location step - one list,
 * defined once in server/src/lib/fieldMarkets.ts. The posting's copy carries {MARKETS...} tokens
 * that marketCopy.ts fills from this.
 */
export function useFieldMarkets(): string[] | null {
  const [markets, setMarkets] = useState<string[] | null>(null);
  useEffect(() => {
    let active = true;
    api.get<{ fieldMarkets?: string[] }>('/api/config')
      .then((config) => { if (active && Array.isArray(config.fieldMarkets)) setMarkets(config.fieldMarkets); })
      // A posting that can't reach the list still reads correctly - it just doesn't name them.
      .catch(() => undefined);
    return () => { active = false; };
  }, []);
  return markets;
}
